'use client'

import dynamic from 'next/dynamic'
import type { MarketRegionData } from '@/services/marketApi'
import type { NewsItem } from '@/services/news'
import type { CryptoPrice } from '@/services/crypto'
import type { SidebarData } from '@/services/sidebarApi'
import GlobalMarkets from '@/components/GlobalMarkets'

const FeaturedNews = dynamic(() => import('@/components/FeaturedNews'), {
  loading: () => (
    <section className="mt-2 px-2 md:px-0" style={{ minHeight: 400 }}>
      <div className="animate-pulse rounded h-6 w-48 mb-3" style={{ backgroundColor: 'var(--border-color)' }} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
        {[1,2,3,4,5,6].map(i => (
          <div key={i} className="py-3 border-b" style={{ borderColor: 'var(--border-color)' }}>
            <div className="animate-pulse rounded h-4 w-full mb-1" style={{ backgroundColor: 'var(--border-color)' }} />
            <div className="animate-pulse rounded h-4 w-3/4" style={{ backgroundColor: 'var(--border-color)' }} />
          </div>
        ))}
      </div>
    </section>
  ),
})

interface Props {
  initialMarketData?: MarketRegionData[] | null
  initialNews?: NewsItem[] | null
  initialCrypto?: Record<string, CryptoPrice> | null
  initialSidebar?: SidebarData | null
  /** E2: kenar çubuğu grafiğinin SSR tohumu. */
  initialSidebarChart?: number[] | null
}

export default function HomePageClient({ initialMarketData, initialNews, initialCrypto, initialSidebar, initialSidebarChart }: Props) {
  return (
    <>
      <GlobalMarkets
        initialData={initialMarketData ?? undefined}
        initialCrypto={initialCrypto ?? undefined}
        initialSidebar={initialSidebar ?? undefined}
        initialSidebarChart={initialSidebarChart ?? undefined}
      />
      <FeaturedNews initialNews={initialNews ?? undefined} />
    </>
  )
}
